import React, { useState, useEffect } from 'react'
import EstrellaRating from './EstrellaRating'
import { reviewsService } from '../../services/reviewsService'

const ListaReviews = ({ entityId, entityType, usuarioActualId }) => {
  const [reviews, setReviews] = useState([])
  const [promedio, setPromedio] = useState({ promedio: 0, total: 0 })
  const [cargando, setCargando] = useState(true)

  useEffect(() => {
    cargarReviews()
  }, [entityId, entityType])

  const cargarReviews = async () => {
    try {
      const [reviewsData, promedioData] = await Promise.all([
        reviewsService.obtenerReviewsDeEntidad(entityType, entityId),
        reviewsService.obtenerPromedioEstrellas(entityType, entityId)
      ])
      
      setReviews(reviewsData)
      setPromedio(promedioData)
    } catch (error) {
      console.error('Error cargando reviews:', error)
    } finally {
      setCargando(false)
    }
  }

  if (cargando) {
    return <div style={{padding: '16px', textAlign: 'center', color: '#6b7280'}}>Cargando calificaciones...</div>
  }

  return (
    <div style={{marginTop: '24px'}}>
      {/* Promedio con imagen del álbum */}
      {promedio.total > 0 && (
        <div style={{
          backgroundColor: '#f8f9fa',
          borderRadius: '12px',
          padding: '20px',
          marginBottom: '24px',
          border: '2px solid #e5e7eb',
          boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
        }}>
          <div style={{display: 'flex', alignItems: 'center', gap: '20px'}}>
            {/* Imagen del álbum */}
            {reviews.length > 0 && reviews[0].entity_image && (
              <img 
                src={reviews[0].entity_image}
                alt="Album cover"
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '8px',
                  objectFit: 'cover',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                  flexShrink: 0
                }}
              />
            )}
            
            {/* Info de calificación */}
            <div style={{flex: 1}}>
              <div style={{display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px'}}>
                <div style={{fontSize: '36px', fontWeight: 'bold', color: '#fbbf24'}}>
                  {promedio.promedio.toFixed(1)}
                </div>
                <div style={{fontSize: '20px', color: '#6b7280'}}>
                  / 5.0
                </div>
              </div>
              
              <div style={{marginBottom: '8px'}}>
                <EstrellaRating calificacion={Math.round(promedio.promedio)} soloLectura />
              </div>
              
              <p style={{
                margin: 0,
                color: '#6b7280',
                fontSize: '14px',
                fontWeight: '500'
              }}>
                Basado en {promedio.total} {promedio.total === 1 ? 'reseña' : 'reseñas'}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Lista de reviews */}
      <div>
        <h3 style={{fontSize: '18px', fontWeight: '600', marginBottom: '16px', color: '#111827'}}>
          Reviews ({reviews.length})
        </h3>
        
        {reviews.length === 0 ? (
          <p style={{color: '#6b7280', textAlign: 'center', padding: '32px 0'}}>
            No hay reviews aún. ¡Sé el primero!
          </p>
        ) : (
          <div>
            {reviews.map((review) => (
              <div 
                key={review.id} 
                style={{
                  border: '1px solid #e5e7eb',
                  borderRadius: '8px',
                  padding: '16px',
                  marginBottom: '16px',
                  backgroundColor: review.user_id === usuarioActualId ? '#eff6ff' : 'white'
                }}
              >
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px'}}>
                  <div style={{display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap'}}>
                    {/* Avatar del usuario */}
                    {review.users?.avatar_url && review.users.avatar_url.trim() !== '' ? (
                      <img
                        src={review.users.avatar_url}
                        alt={review.users.username || review.users.email || 'Usuario'}
                        style={{
                          width: '36px',
                          height: '36px',
                          borderRadius: '50%',
                          objectFit: 'cover',
                          flexShrink: 0,
                          border: '2px solid #8b5cf6'
                        }}
                        onError={(e) => {
                          e.target.style.display = 'none';
                          const fallback = document.createElement('div');
                          fallback.style.cssText = 'width: 36px; height: 36px; border-radius: 50%; background-color: #8b5cf6; display: flex; align-items: center; justify-content: center; font-size: 14px; font-weight: bold; color: white; flex-shrink: 0;';
                          fallback.textContent = (review.users?.username?.[0] || review.users?.email?.[0] || 'U').toUpperCase();
                          e.target.parentElement.insertBefore(fallback, e.target);
                        }}
                      />
                    ) : (
                      <div style={{
                        width: '36px',
                        height: '36px',
                        borderRadius: '50%',
                        backgroundColor: '#8b5cf6',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        color: 'white',
                        flexShrink: 0
                      }}>
                        {(review.users?.username?.[0] || review.users?.email?.[0] || 'U').toUpperCase()}
                      </div>
                    )}
                    <div style={{display: 'flex', flexDirection: 'column', gap: '4px'}}>
                      <strong style={{color: '#111827', fontSize: '14px'}}>
                        {review.users?.username || review.users?.email || 'Usuario'}
                      </strong>
                      <div style={{display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap'}}>
                        <EstrellaRating calificacion={review.rating} soloLectura tamaño="sm" />
                        {review.user_id === usuarioActualId && (
                          <span style={{
                            fontSize: '12px',
                            backgroundColor: '#dbeafe',
                            color: '#1e40af',
                            padding: '4px 8px',
                            borderRadius: '4px'
                          }}>
                            Tu review
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <span style={{fontSize: '12px', color: '#6b7280'}}>
                    {new Date(review.created_at).toLocaleDateString('es-ES')}
                  </span>
                </div>
                
                {review.title && (
                  <h4 style={{fontWeight: '600', color: '#111827', marginBottom: '8px'}}>
                    {review.title}
                  </h4>
                )}
                
                {review.content && (
                  <p style={{color: '#374151', lineHeight: '1.5'}}>
                    {review.content}
                  </p>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default ListaReviews